import Modal from 'bootstrap/js/dist/modal';

const STORAGE_KEY_PREFIX = 'citizenecho.infobox.shown.';

/**
 * The info box is shown automatically the first time the dialog is opened in the tab.
 * It can always be reopened via the info button next to the dialog title.
 */
export function showDialogInfoBox(force: boolean = false): void {
    const modalEl = document.getElementById('dialogInfoModal');
    if (!modalEl) return;

    const slug = (window as any).dialogSlug || '';
    const storageKey = `${STORAGE_KEY_PREFIX}${slug}`;

    if (!force && readShown(storageKey)) return;

    writeShown(storageKey);
    Modal.getOrCreateInstance(modalEl).show();
}

/** Wires up the info button next to the dialog title. */
export function registerDialogInfoButton(): void {
    const button = document.getElementById('dialogInfoButton');
    button?.addEventListener('click', () => showDialogInfoBox(true));
}

function readShown(key: string): boolean {
    try {
        return window.sessionStorage.getItem(key) === '1';
    } catch {
        return false;
    }
}

function writeShown(key: string): void {
    try {
        window.sessionStorage.setItem(key, '1');
    } catch {
        // sessionStorage may be blocked - the box is then shown every time
    }
}
